import Helper from "../util/helper";
import { privGetRequest, privPostRequestWithResponseSchemaHeader, privPutRequest } from "../vidCloud/priv";

const SignatureService = {};

SignatureService.pendingSignatures = (emailId) => {
  const body = {
    "Terms": {
      "EmailId": emailId
    }
  };

  return privPostRequestWithResponseSchemaHeader(`/pendingsignatures/searches`, body);
}

SignatureService.signatureFormResponse = (signerGuid, form, formResponse, isAdvancedForm) => {
  const formResponseDTO = Helper.responsesToForm(form, formResponse, isAdvancedForm);
  return privPutRequest(`/signatures/${signerGuid}/formresponse`, formResponseDTO);
}

SignatureService.getSignatureAttachments = (signerGuid) => {
  return privGetRequest(`/signatures/${signerGuid}/attachments`);
}

SignatureService.getAttachmentRenderPage = (signerGuid, attachmentGuid, currentPage) => {
  return privGetRequest(`/signatures/${signerGuid}/attachments/${attachmentGuid}/render/pages/${currentPage}`);
}

export default SignatureService;